import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { type FunctionComponent } from "react";

import { BaseLinkContextProvider } from "scmp-app/components/common/base-link/context";
import { Portal } from "scmp-app/components/common/portal";
import { AgendaFilter } from "scmp-app/components/plus/news-agenda/filter";
import { PlusPaywallSuspense } from "scmp-app/components/plus/plus-paywall-suspense";
import { pathname as plusAgendaPathname } from "scmp-app/pages/plus/agenda";

import { AgendaItem } from "./item";
import {
  AgendaContainer,
  Container,
  Filter,
  HeaderContainer,
  PlaceHolderContainer,
  StyledBaseLink,
  StyledImagePlaceholder,
  Title,
} from "./styles";

type Props = {
  className?: string;
};

const PlusHomepageAgendaBlockElementId = "plus-homepage-agenda-block";

export const AgendaBlock: FunctionComponent<Props> = ({ className }) => (
  <PlusPaywallSuspense
    fallback={
      <PlaceHolderContainer>
        <StyledImagePlaceholder />
      </PlaceHolderContainer>
    }
  >
    <Container className={className}>
      <HeaderContainer>
        <Title>News Agenda</Title>
        <Filter>
          <AgendaFilter isDefaultCheckedKeyEvents={true} withDatePicker={false}>
            {({ firstWithDetailsKeyEventAgenda, topics }) => (
              <Portal selector={`#${PlusHomepageAgendaBlockElementId}`} replace>
                {topics.map(({ node }, index) => (
                  <AgendaItem
                    isFirstKeyEventAgenda={index === firstWithDetailsKeyEventAgenda}
                    key={index}
                    needToShowUpdatedLabel={true}
                    reference={node}
                  />
                ))}
              </Portal>
            )}
          </AgendaFilter>
        </Filter>
      </HeaderContainer>
      <AgendaContainer id={PlusHomepageAgendaBlockElementId} />
      <BaseLinkContextProvider customQueryParameters={{ pgtype: "homepage" }}>
        <StyledBaseLink pathname={plusAgendaPathname}>
          View more events
          <ArrowRightIcon />
        </StyledBaseLink>
      </BaseLinkContextProvider>
    </Container>
  </PlusPaywallSuspense>
);

AgendaBlock.displayName = "AgendaBlock";
